var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolname-container",class:{
    actions: _vm.toolComponent === 'Actions',
    grid: _vm.toolComponent === 'Grid',
    imageBox: _vm.toolComponent === 'ImageBox',
    generate: _vm.toolComponent === 'Generate'
  }},[_c(_vm.toolComponent,{key:_vm.componentKey,tag:"component",attrs:{"edition":_vm.edition,"is-digital":_vm.isDigital}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }